import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import LoadingOverlay from 'react-loading-overlay';
import { Icon } from '@contently/toolkit';

const LoadingMask = (props) => {
  const { active, children } = props

  const StyledIcon = styled(Icon)`
    font-size: 26px;
    position: absolute;
    top: 10px;
  `;

  return (
    <LoadingOverlay
      active={active}
      spinner={<StyledIcon fixedWidth={false} type='spinner' spin='clockwise'/>} 
      styles={{
        overlay: (base) => ({
          ...base,
          background: '#fff',
          opacity: 0.7
        })
      }}
     >
     {children}
     </LoadingOverlay>
  );
};

LoadingMask.propTypes = {
  active: PropTypes.bool.isRequired,
  children: PropTypes.element.isRequired
};

export default LoadingMask;


// WEBPACK FOOTER //
// ./app/javascript/app/components/toolkit/loadingMask.jsx